import { Navigate } from 'react-router-dom'
import { useHrContext } from '@/hooks/use-api'

/** Sends the signed-in user to their own employee detail page. */
export default function MyProfileRedirect() {
  const { data, isLoading, isError } = useHrContext()
  if (isLoading) {
    return (
      <main className="container mx-auto p-6">
        <p role="status" aria-live="polite" className="py-12 text-center text-muted-foreground">
          Loading your profile…
        </p>
      </main>
    )
  }
  if (isError || !data?.employeeId) {
    return (
      <main className="container mx-auto p-6">
        <p role="alert" className="py-12 text-center text-muted-foreground">
          No employee record is linked to your account. Please contact HR.
        </p>
      </main>
    )
  }
  return <Navigate to={`/hr/employees/${data.employeeId}`} replace />
}
